var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"categories-section"},[_c('div',{staticClass:"row d-flex justify-content-center mt-4"},[_c('div',{staticClass:"col-md-6"},[_c('class-menu')],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('examMenu')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }